var React = require('react');

function SDCLockRestrict18N (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M10.00006,11.45638v1.389a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5v-1.389a1.5,1.5,0,1,1,2,0Z","fill":"var(--iconFill, #464646)","key":0}),React.createElement("path",{"d":"M15.5,5H13.68805C13.39,1.97424,11.72748.25,9,.25S4.61,1.97424,4.312,5H2.5a.5.5,0,0,0-.5.5v11a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5V5.5A.5.5,0,0,0,15.5,5ZM9,1.75c1.88434,0,2.95679,1.09241,3.19745,3.25H5.80255C6.04321,2.84241,7.11566,1.75,9,1.75ZM14.5,15.5H3.5v-9h11Z","fill":"var(--iconFill, #464646)","key":1})]));
}

SDCLockRestrict18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SDCLockRestrict18N;

SDCLockRestrict18N.default = SDCLockRestrict18N;
